import http from '@/utils/http';

export default {
	list: data => http({ url: '/api/admin/v1/fulfillment/list', data }),
	detail: data => http({ url: '/api/admin/v1/fulfillment/detail', data }),
	createFulfillments: data => http({ url: '/api/admin/v1/transport/createFulfillments', data }),
	fulfillmentHistory: data => http({ url: '/api/admin/v1/transport/fulfillmentHistory', data }),
};
